/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.AccessTokenInfoResponse,
  (params: vp.AccessTokenInfoRequest) => Promise<vp.AccessTokenInfoResponse>,
  (params: vp.AccessTokenInfoRequest) => void,
  () => void,
];

function useFetchiQ11AccessTokenInfo({ api }: HookProps): ReturnTuple {
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  const source = axios.CancelToken.source();

  const [response, setResponse] = useState<vp.AccessTokenInfoResponse>({
    Success: false,
    ErrorMessage: '',
    AccessToken: '',
    Processor: '',
    ExtraInfo: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [request, setRequest] = useState<vp.AccessTokenInfoRequest>({
    IframeKey: '',
    PaymentSelectionMethod: '',
    ForOnboarding: false,
  });
  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, `${t('defaultLoading')}`, 'fullScreen');

      const res = await api.fetchiQ11AccessTokenInfo(request, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (params: vp.AccessTokenInfoRequest) => api.fetchiQ11AccessTokenInfo(params, source),
    (params: vp.AccessTokenInfoRequest) => {
      setRequest(params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        AccessToken: '',
        Processor: '',
        ExtraInfo: {},
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchiQ11AccessTokenInfo);
